"use client";

import { TreasuryFormMock } from "./mocks/TreasuryFormMock";
import { KpiDashboardMock } from "./mocks/KpiDashboardMock";
import { UsaliScheduleMock } from "./mocks/UsaliScheduleMock";
import { ProcurementTableMock } from "./mocks/ProcurementTableMock";
import { MyTasksMock } from "./mocks/MyTasksMock";

/**
 * ModuleVisuals — реалистичные мок-скриншоты для каждого модуля
 * Заменяют пустые placeholder "▓Module visual▓"
 */

/* ── Treasury ── */
export function TreasuryVisual() {
  return (
    <div className="w-full h-full">
      <TreasuryFormMock />
    </div>
  );
}

/* ── KPI Dashboard ── */
export function KpiVisual() {
  return (
    <div className="w-full h-full">
      <KpiDashboardMock />
    </div>
  );
}

/* ── USALI ── */
export function UsaliVisual() {
  return (
    <div className="w-full h-full">
      <UsaliScheduleMock />
    </div>
  );
}

/* ── Procurement ── */
export function ProcurementVisual() {
  return (
    <div className="w-full h-full">
      <ProcurementTableMock />
    </div>
  );
}

/* ── AI Assistant / My Tasks ── */
export function AiVisual() {
  return (
    <div className="w-full h-full">
      <MyTasksMock />
    </div>
  );
}
